import React from 'react'
import LuxPlusLandingPartnerOffersList from './LuxPlusLandingPartnerOffersList'

function LuxPlusLoggedInPartnerOffersTabSection() {
  return <LuxPlusLandingPartnerOffersList />
}

export default LuxPlusLoggedInPartnerOffersTabSection
